<template>
  <div class="auth-layout">
    <!-- Left Column -->
    <div class="auth-left">
      <div class="auth-left__logo">
        <img
          :src="myDesskWhite"
          alt="mydessk"
          style="height: 28px; width: auto"
        />
        <!-- logo text is in the SVG -->
      </div>

      <div class="auth-left__content">
        <h1 class="auth-left__headline">
          Deja de trabajar<br />a ciegas.<br /><span
            class="auth-left__headline--accent"
            >Tu negocio tiene<br />que crecer.</span
          >
        </h1>

        <div class="auth-left__illustration">
          <svg
            viewBox="0 0 260 148"
            fill="none"
            class="auth-left__illustration-svg"
          >
            <!-- Document/table card -->
            <rect
              x="0"
              y="18"
              width="108"
              height="130"
              rx="10"
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.1)"
              stroke-width="0.8"
            />
            <rect
              x="10"
              y="30"
              width="52"
              height="5"
              rx="2.5"
              fill="rgba(255,255,255,0.15)"
            />
            <rect
              x="10"
              y="40"
              width="32"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="10"
              y="53"
              width="88"
              height="0.7"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="10"
              y="61"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.1)"
            />
            <rect
              x="58"
              y="61"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.06)"
            />
            <rect
              x="10"
              y="70"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.1)"
            />
            <rect
              x="58"
              y="70"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.06)"
            />
            <rect
              x="10"
              y="79"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.1)"
            />
            <rect
              x="58"
              y="79"
              width="38"
              height="3.5"
              rx="1.75"
              fill="rgba(255,255,255,0.06)"
            />
            <rect
              x="10"
              y="93"
              width="88"
              height="0.7"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="54"
              y="100"
              width="44"
              height="6"
              rx="2"
              fill="rgba(62,207,180,0.25)"
            />
            <rect
              x="56"
              y="102"
              width="40"
              height="2.5"
              rx="1.25"
              fill="#3ecfb4"
              opacity="0.7"
            />
            <rect
              x="10"
              y="114"
              width="88"
              height="7"
              rx="3.5"
              fill="rgba(62,207,180,0.15)"
              stroke="rgba(62,207,180,0.3)"
              stroke-width="0.6"
            />
            <rect
              x="28"
              y="116.5"
              width="48"
              height="2"
              rx="1"
              fill="rgba(62,207,180,0.5)"
            />
            <!-- Chart card -->
            <rect
              x="118"
              y="0"
              width="142"
              height="88"
              rx="10"
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.1)"
              stroke-width="0.8"
            />
            <rect
              x="130"
              y="12"
              width="48"
              height="4.5"
              rx="2.25"
              fill="rgba(255,255,255,0.15)"
            />
            <rect
              x="130"
              y="21"
              width="28"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.07)"
            />
            <rect
              x="130"
              y="33"
              width="13"
              height="28"
              rx="3"
              fill="rgba(83,74,183,0.5)"
            />
            <rect
              x="149"
              y="43"
              width="13"
              height="18"
              rx="3"
              fill="rgba(62,207,180,0.4)"
            />
            <rect
              x="168"
              y="37"
              width="13"
              height="24"
              rx="3"
              fill="rgba(83,74,183,0.35)"
            />
            <rect
              x="187"
              y="29"
              width="13"
              height="32"
              rx="3"
              fill="rgba(62,207,180,0.55)"
            />
            <rect
              x="206"
              y="49"
              width="13"
              height="12"
              rx="3"
              fill="rgba(83,74,183,0.3)"
            />
            <rect
              x="130"
              y="65"
              width="94"
              height="0.6"
              fill="rgba(255,255,255,0.08)"
            />
            <rect
              x="130"
              y="71"
              width="48"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.08)"
            />
            <!-- Clients card -->
            <rect
              x="118"
              y="98"
              width="142"
              height="50"
              rx="10"
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.1)"
              stroke-width="0.8"
            />
            <circle cx="136" cy="114" r="8" fill="rgba(62,207,180,0.2)" />
            <circle cx="136" cy="114" r="4" fill="rgba(62,207,180,0.6)" />
            <rect
              x="150"
              y="109"
              width="40"
              height="4"
              rx="2"
              fill="rgba(255,255,255,0.15)"
            />
            <rect
              x="150"
              y="117"
              width="24"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.07)"
            />
            <circle cx="136" cy="134" r="8" fill="rgba(186,117,23,0.2)" />
            <circle cx="136" cy="134" r="4" fill="rgba(186,117,23,0.6)" />
            <rect
              x="150"
              y="129"
              width="30"
              height="4"
              rx="2"
              fill="rgba(255,255,255,0.12)"
            />
            <rect
              x="150"
              y="137"
              width="20"
              height="3"
              rx="1.5"
              fill="rgba(255,255,255,0.06)"
            />
          </svg>
        </div>

        <div class="auth-left__stat">
          <div class="auth-left__stat-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M3 17V8l7-5 7 5v9"
                stroke="#3ecfb4"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <rect
                x="7.5"
                y="11"
                width="5"
                height="6"
                rx="1"
                fill="rgba(62,207,180,0.3)"
                stroke="#3ecfb4"
                stroke-width="1.2"
              />
            </svg>
          </div>
          <div>
            <span class="auth-left__stat-number">+200</span>
            <span class="auth-left__stat-label">comercios registrados</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="auth-right">
      <div class="auth-right__container">
        <h2 class="auth-right__title">Bienvenido de vuelta</h2>
        <p class="auth-right__subtitle">
          ¿No tienes cuenta?
          <router-link :to="{ name: 'register' }" class="auth-right__link">
            Regístrate gratis
          </router-link>
        </p>

        <!-- Google Button -->
        <a :href="googleAuthUrl" class="auth-google-btn">
          <svg width="20" height="20" viewBox="0 0 48 48">
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
          </svg>
          <span>Continuar con Google</span>
        </a>

        <!-- Separator -->
        <div class="auth-separator">
          <span>o con correo</span>
        </div>

        <!-- Login Form -->
        <el-form
          :model="formLogin"
          :rules="rules"
          ref="formLogin"
          @submit.native.prevent="onSubmit"
        >
          <el-form-item prop="email">
            <label class="auth-label">Correo electrónico</label>
            <el-input
              v-model="formLogin.email"
              placeholder="tu@correo.com"
              autocomplete="on"
              name="email"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <label class="auth-label">Contraseña</label>
            <el-input
              v-model="formLogin.password"
              type="password"
              show-password
              placeholder="Tu contraseña"
              autocomplete="on"
              name="password"
            ></el-input>
          </el-form-item>

          <div class="auth-forgot">
            <router-link :to="{ name: 'recovery-password' }">
              ¿Olvidaste tu contraseña?
            </router-link>
          </div>

          <button
            class="auth-submit-btn auth-submit-btn--login"
            type="submit"
            @click.prevent="onSubmit"
          >
            Iniciar sesión
          </button>
        </el-form>
      </div>

      <!-- Mobile Logo -->
      <div class="auth-mobile-logo">
        <img
          :src="myDesskBlack"
          alt="mydessk"
          style="height: 30px; width: auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Validate from "@/assets/validate";
import { myDesskWhite, myDesskBlack } from "@/services/resources";
import AuthServices from "../../services/AuthServices";

export default {
  name: "LoginPage",
  data: () => ({
    myDesskWhite,
    myDesskBlack,
    googleAuthUrl:
      (process.env.VUE_APP_API_URL || "http://localhost:8000/api/").replace(
        "/api/",
        ""
      ) +
      "/auth/google?mode=login&client_url=" +
      encodeURIComponent(window.location.origin),
    formLogin: {
      email: "",
      password: ""
    },
    rules: {
      email: [{ ...Validate.rules.required(), ...Validate.rules.email() }],
      password: [Validate.rules.required()]
    }
  }),
  methods: {
    onSubmit() {
      this.$refs.formLogin.validate(async valid => {
        if (valid) {
          try {
            let response = await this.$store.dispatch("login", this.formLogin);
            const { success, message } = response.data;
            if (success) window.location.reload();
            else
              this.$notifications.error({
                message
              });
          } catch (error) {
            return false;
          }
        }
      });
    },
    async handleGoogleToken() {
      const urlParams = new URLSearchParams(window.location.search);
      const googleToken = urlParams.get("google_token");
      const error = urlParams.get("error");

      if (error === "google_cancelled") {
        this.$notifications.error({
          message: "Inicio de sesión con Google cancelado"
        });
        window.history.replaceState({}, document.title, "/login");
        return;
      }

      if (error === "no_account") {
        this.$notifications.error({
          message:
            "No encontramos una cuenta con este correo de Google. Regístrate primero para comenzar."
        });
        window.history.replaceState({}, document.title, "/login");
        return;
      }

      if (googleToken) {
        const isNewUser = urlParams.get("new_user") === "true";
        // Save token so Axios can use it for the profile request
        this.$store.commit("setUser", { token: googleToken });
        try {
          const response = await AuthServices.getProfile();
          if (response.data && response.data.success) {
            const { user } = response.data;
            this.$store.commit("setUser", { ...user, token: googleToken });
          }
        } catch (e) {
          // Profile fetch failed, continue with token only
        }
        // New Google users go to onboarding, existing users go to dashboard
        window.location.href = isNewUser ? "/onboarding" : "/dashboard";
      }
    }
  },
  props: ["query"],
  mounted() {
    if (this.query && this.query.email) this.formLogin.email = this.query.email;
    this.handleGoogleToken();

    // Show logout reason if redirected from forced logout
    const logoutReason = localStorage.getItem("logout_reason");
    if (logoutReason) {
      this.$notifications.warning({
        title: "Sesión cerrada",
        message: logoutReason
      });
      localStorage.removeItem("logout_reason");
    }
  }
};
</script>

<style scoped lang="scss">
@import "./Login.scss";
</style>
